<template>
  <div>
    <v-overlay :value="loading">
      <v-breadcrumbs
          divider=">"
      ></v-breadcrumbs>
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-overlay
      :value="excelLoading"
      :absolute="absolute"
    >
      <v-progress-circular
        :rotate="360"
        :size="100"
        :width="15"
        :value="value"
        color="white"
      >
        {{ value }}%
      </v-progress-circular>
    </v-overlay>
    <v-row class="mb-6">
      <v-col cols="12" md="4">
        <v-card elevation="1" class="rounded-lg" style="height: 150px">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-folder-search</v-icon>
            <span class="primary--text font-weight-medium">Seleziona un Progetto</span>
          </v-card-title>
          <v-card-actions>
            <if65-autocomplete
                id="project-selector"
                class="align-center"
                v-model="projectId"
                :label='``'
                :dense="true"
                :api="projectApi"
                :dark="false"
                style="width: 100%;"
                :placeholder="`Cerca progetto...`"
                :flat="true"
                no-focus-effects />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" v-if="this.$store.state.user && ['ADMIN','HEAD', 'PURCHASE_OPERATOR'].includes(this.$store.state.user.role)">
        <v-card elevation="1" class="rounded-lg expandable-hours-card"
               :style="{ height: '150px', 'min-height': '150px' }">
          <v-card-title class="d-flex align-center px-4 py-2">
            <v-icon color="primary" class="mr-2">mdi-account-clock</v-icon>
            <span class="primary--text font-weight-medium">Ore del giorno {{ todayDate }}</span>
            <v-spacer></v-spacer>
            <v-icon v-if="tasksStatsYesterday.length > 3" color="grey" size="16">mdi-chevron-down</v-icon>
          </v-card-title>

          <div v-if="tasksStatsYesterday.length > 0" class="operators-list px-3">
            <div v-for="(item, index) in tasksStatsYesterday" :key="item.operator.id"
                 :class="{ 'hidden-item': index >= 3 }"
                 class="operator-item d-flex align-center justify-space-between py-2 border-bottom">
              <div class="d-flex align-center">
                <v-avatar size="20" class="mr-2" color="primary">
                  <span class="white--text text-caption font-weight-bold">
                    {{ getInitials(item.operator.full_name) }}
                  </span>
                </v-avatar>
                <span class="text-body-2 font-weight-medium">
                  {{ item.operator.full_name }}
                </span>
              </div>
              <span class="primary--text font-weight-bold">{{ formatDecimalHoursToHours(item.hours) }}h</span>
            </div>
          </div>

          <div v-else class="d-flex flex-column align-center justify-center" style="height: 100px;">
            <v-icon color="grey lighten-1" size="32" class="mb-2">mdi-clock-outline</v-icon>
            <span class="grey--text text-body-2">Nessuna ora registrata oggi</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card elevation="1" class="rounded-lg" style="height: 150px">
          <v-card-title class="d-flex align-center px-4 py-2">
            <v-icon color="success" class="mr-2">mdi-chart-timeline-variant</v-icon>
            <span class="success--text font-weight-medium">Statistiche Ore</span>
          </v-card-title>
          <v-card-text class="px-4 py-3">
            <div class="d-flex align-center justify-space-between mb-3">
              <div class="d-flex align-center">
                <v-icon color="success" size="20" class="mr-2">mdi-calendar-today</v-icon>
                <span class="text-body-2">Ore del giorno:</span>
              </div>
              <span class="success--text font-weight-bold" v-if="tasksStatsYesterday[0] != null">{{ totalHoursYesterday }}h</span>
              <span class="success--text font-weight-bold" v-else>0h</span>
            </div>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-icon color="success" size="20" class="mr-2">mdi-calendar-month</v-icon>
                <span class="text-body-2">Ore totali:</span>
              </div>
              <span class="success--text font-weight-bold">{{ totalHours || 0 }}h</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card elevation="1" class="main-card rounded-lg">
          <v-card-title class="py-4 px-6">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-clipboard-text-outline</v-icon>
                <span class="text-h6 font-weight-medium primary--text">Tasks</span>
                <v-chip class="ml-3" color="primary" small>{{ tasksCount }}</v-chip>
              </div>
              <div class="d-flex">
                <v-btn
                  color="error"
                  text
                  @click="clearAllFilters"
                  class="mr-2"
                  :disabled="!hasActiveFilters">
                  <v-icon left>mdi-filter-remove</v-icon>
                  Cancella filtri
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  :loading="excelLoading"
                  @click="exportInExcel"
                  class="excel-export-btn">
                  <v-icon left>mdi-microsoft-excel</v-icon>
                  Esporta Excel
                </v-btn>
              </div>
            </div>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="tasks"
            :options.sync="dtOptions"
            :items-per-page="10"
            :server-items-length="tasksCount"
            hide-default-footer
            :loading="loading"
            loading-text="Caricamento in corso..."
            class="elevation-0 task-table">
            <template #body.prepend>
              <tr class="filter-row">
                <td>
                  <div class="d-flex align-center">
                    <if65-autocomplete
                      id="filter-customer"
                      v-model="filters.customer"
                      :api="safeCustomerService"
                      :extra-params="prependExtraParams"
                      :dark="false"
                      :label="''"
                      :placeholder="'Cerca insegna...'"
                      :dense="true"
                      :flat="true"
                      solo
                      class="flex-grow-1"/>
                    <v-btn
                      v-if="filters.customer"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="filters.customer = null">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <if65-multi-select
                      id="filter-operators"
                      v-model="filters.operators"
                      :api="operatorApi"
                      :extra-params="prependExtraParams"
                      :dark="false"
                      :label="''"
                      :placeholder="'Cerca operatore...'"
                      :dense="true"
                      :flat="true"
                      solo
                      @focus="enableOperatorAutocomplete"
                      @click="enableOperatorAutocomplete"
                      class="flex-grow-1"/>
                    <v-btn
                      v-if="filters.operators && filters.operators.length > 0"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="filters.operators = []">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <if65-autocomplete
                      id="filter-project-code"
                      v-model="projectCode"
                      :api="projectCodeApi"
                      :dark="false"
                      :label="''"
                      :placeholder="'Cerca codice...'"
                      :dense="true"
                      :flat="true"
                      solo
                      class="flex-grow-1"
                      @focus="enableProjectCodeAutocomplete"
                      @click="enableProjectCodeAutocomplete"/>
                    <v-btn
                      v-if="projectCode"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="projectCode = null; projectId = null;">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <if65-multi-select
                      id="filter-project-name"
                      v-model="filters.project_name"
                      :api="projectApi"
                      :extra-params="{choices_with_name:''}"
                      :dark="false"
                      :label="''"
                      :placeholder="'Cerca progetto...'"
                      :dense="true"
                      :flat="true"
                      solo
                      class="flex-grow-1"/>
                    <v-btn
                      v-if="filters.project_name && filters.project_name.length > 0"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="filters.project_name = []">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <if65-multi-select
                      id="filter-activities"
                      v-model="filters.activities"
                      :api="safeActivityService"
                      :extra-params="prependExtraParams"
                      :dark="false"
                      :label="''"
                      :placeholder="'Cerca attività...'"
                      :dense="true"
                      :flat="true"
                      solo
                      @focus="enableGeneralAutocompletes"
                      @click="enableGeneralAutocompletes"
                      class="flex-grow-1"/>
                    <v-btn
                      v-if="filters.activities && filters.activities.length > 0"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="filters.activities = []">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <if65-multi-select
                      id="filter-products"
                      v-model="filters.products"
                      :api="safeProductService"
                      :extra-params="prependExtraParams"
                      :dark="false"
                      :label="''"
                      :placeholder="'Cerca prodotto...'"
                      :dense="true"
                      :flat="true"
                      solo
                      @focus="enableGeneralAutocompletes"
                      @click="enableGeneralAutocompletes"
                      class="flex-grow-1"/>
                    <v-btn
                      v-if="filters.products && filters.products.length > 0"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="filters.products = []">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
<!--                  <if65-autocomplete
                    v-model="filters.sub_activities"
                    hint="Sub Act..."
                    :api="safeSubActivityService"
                    :extra-params="prependExtraParams"
                    :multiple="true"
                    :dark="false"
                    :placeholder="``"
                    :label='``'>
                  </if65-autocomplete>-->
                </td>
                <td>
                  <div class="d-flex align-center">
                    <if65-date-picker
                      v-model="createdAtRangeToSearch"
                      :label="'Data'"
                      :placeholder="'Seleziona date...'"
                      :dense="true"
                      :range="true"
                      dateFormat="dd/MM/yyyy"
                      clearable
                      single-line
                      hide-details
                      class="flex-grow-1"
                    />
                    <v-btn
                      v-if="createdAtRangeToSearch && createdAtRangeToSearch.length > 0"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="createdAtRangeToSearch = []">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <v-text-field
                      v-model="orderNumberToSearch"
                      placeholder="Cerca ordine..."
                      dense
                      flat
                      solo
                      single-line
                      hide-details
                      clearable
                      class="flex-grow-1"
                      @focus="enableOrderNumberAutocomplete"
                      @click="enableOrderNumberAutocomplete">
                    </v-text-field>
                    <v-btn
                      v-if="orderNumberToSearch && orderNumberToSearch.trim() !== ''"
                      icon
                      x-small
                      color="error"
                      class="ml-1 mt-1"
                      @click="orderNumberToSearch = ''">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td>
                </td>
                <td></td>
              </tr>
              <div class="mb-3"></div>
            </template>
            <template v-slot:item.customer="{item}">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.customer, 8) }}
                  </span>
                </template>
                <span>{{item.customer }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.operator_full_name="{item}">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.operator_full_name, 10) }}
                  </span>
                </template>
                <span>{{item.operator_full_name }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.project_code="{item}">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.project_code, 8) }}
                  </span>
                </template>
                <span>{{item.project_code }}</span>
              </v-tooltip>
            </template>
            <template #item.project_name="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ truncateString(item.project_name, 25) }}
                  </span>
                </template>
                <span>{{item.project_name }}</span>
              </v-tooltip>
            </template>
            <template #item.product_name="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.product_name, 15)}}
                  </span>
                </template>
                <span>{{item.product_name }}</span>
              </v-tooltip>
            </template>
            <template #item.activity_name="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.activity_name, 10)}}
                  </span>
                </template>
                <span>{{item.activity_name }}</span>
              </v-tooltip>
            </template>
            <template #item.sub_activity_name="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.sub_activity_name, 8)}}
                  </span>
                </template>
                <span>{{item.sub_activity_name }}</span>
              </v-tooltip>
            </template>
            <template #item.order_number="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{truncateString(item.order_number, 8)}}
                  </span>
                </template>
                <span>{{item.order_number }}</span>
              </v-tooltip>
            </template>
            <template #item.task_date="{ item }">
              <v-chip
                color="primary"
                text-color="white"
                x-small
                class="font-weight-medium"
              >
                <v-icon left x-small>mdi-calendar</v-icon>
                {{ formatDate(item.task_date) }}
              </v-chip>
            </template>
            <template #item.actions="{ item }">
              <div class="d-flex">
                <v-btn
                  icon
                  x-small
                  color="primary"
                  class="mr-1"
                  :disabled="!canEditTask(item)"
                  @click="editTask(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  color="error"
                  :disabled="!canManipulate(item)"
                  @click="deleteTask(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
              <task-delete-dialog
                v-if="showTaskDeleteDialog"
                v-model="showTaskDeleteDialog"
                :task-id="item.id"
                :task="task"
                @confirmed="onTaskDeleteConfirmed"
              />
            </template>
            <template #item.hours="{ item }">
              <v-chip
                color="success"
                text-color="white"
                small
                class="font-weight-medium px-2"
              >
                <v-icon left small>mdi-clock-outline</v-icon>
                {{ item.hours}} ore
              </v-chip>
            </template>
            <template #item.description_truncated="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.description_truncated }}</span>
                </template>
                <span>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <div class="text-center py-8">
                <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-clipboard-text-off</v-icon>
                <h3 class="grey--text text--lighten-1 mb-2">Nessun task trovato</h3>
                <p class="grey--text">Non ci sono task per i filtri selezionati</p>
              </div>
            </template>
            <template v-if="tasks.length > 0 && taskStats" v-slot:footer>
              <div class="table-footer pa-3">
                <div class="footer-stats d-flex align-center justify-space-between flex-wrap">
                  <!-- Ore totali - Sempre visibili -->
                  <div class="stat-item hours-summary d-flex align-center mr-4 mb-2">
                    <v-icon color="success" size="20" class="mr-2">mdi-clock-check</v-icon>
                    <div class="stat-content">
                      <span class="stat-label">{{ isAdmin ? 'Ore totali:' : 'Le mie ore:' }}</span>
                      <span class="stat-value success--text font-weight-bold ml-1">{{ taskStats.total_hours }}h</span>
                      <span v-if="taskStats.first_task_date" class="date-info grey--text ml-2">
                        dal {{ formatDate(taskStats.first_task_date, 'DD/MM/YYYY') }}
                      </span>
                    </div>
                  </div>

                  <!-- Media ore per task - Sempre visibili -->
                  <div class="stat-item d-flex align-center mr-4 mb-2">
                    <v-icon color="info" size="20" class="mr-2">mdi-calculator</v-icon>
                    <div class="stat-content">
                      <span class="stat-label">{{ isAdmin ? 'Media per task:' : 'Mia media per task:' }}</span>
                      <span class="stat-value info--text font-weight-bold ml-1">{{ taskStats.avg_hours_per_task }}h</span>
                    </div>
                  </div>

                  <!-- Numero task - Sempre visibili -->
                  <div class="stat-item d-flex align-center mr-4 mb-2">
                    <v-icon color="primary" size="20" class="mr-2">mdi-format-list-numbered</v-icon>
                    <div class="stat-content">
                      <span class="stat-label">{{ isAdmin ? 'Task totali:' : 'I miei task:' }}</span>
                      <span class="stat-value primary--text font-weight-bold ml-1">{{ taskStats.total_tasks }}</span>
                    </div>
                  </div>

                  <!-- Media ore per giorno - Sempre visibili -->
                  <div class="stat-item d-flex align-center mr-4 mb-2">
                    <v-icon color="orange" size="20" class="mr-2">mdi-calendar-clock</v-icon>
                    <div class="stat-content">
                      <span class="stat-label">{{ isAdmin ? 'Media al giorno:' : 'Mia media al giorno:' }}</span>
                      <span class="stat-value orange--text font-weight-bold ml-1">{{ taskStats.avg_hours_per_day }}h</span>
                    </div>
                  </div>

                  <!-- Operatori coinvolti - Solo ADMIN -->
                  <div v-if="isAdmin" class="stat-item d-flex align-center mr-4 mb-2">
                    <v-icon color="purple" size="20" class="mr-2">mdi-account-group</v-icon>
                    <div class="stat-content">
                      <span class="stat-label">Operatori:</span>
                      <span class="stat-value purple--text font-weight-bold ml-1">{{ taskStats.total_operators }}</span>
                    </div>
                  </div>

                  <!-- Media ore per operatore - Solo ADMIN -->
                  <div v-if="isAdmin" class="stat-item d-flex align-center mb-2">
                    <v-icon color="teal" size="20" class="mr-2">mdi-account-clock</v-icon>
                    <div class="stat-content">
                      <span class="stat-label">Media per operatore:</span>
                      <span class="stat-value teal--text font-weight-bold ml-1">{{ taskStats.avg_hours_per_operator }}h</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </v-data-table>

          <custom-pagination
            v-model="dtOptions.page"
            :total-items="tasksCount"
            :items-per-page="dtOptions.itemsPerPage || 10"
            @update:items-per-page="updateItemsPerPage"
          ></custom-pagination>

          <task-dialog
            v-if="showTaskDialog"
            v-model="showTaskDialog"
            :task-id="taskToEdit"
            @taskSaved="onTaskSaved"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import If65DatePicker from "../../components/widgets/If65DatePicker.vue";
import TaskDeleteDialog from "./TaskDeleteDialog.vue";
import TaskDialog from "./TaskDialog.vue";
import CustomPagination from "../../components/widgets/CustomPagination";
import _ from "lodash";
import { debounce } from 'lodash';
import {format, parseISO} from "date-fns";
import FileSaver from 'file-saver'
import moment from "moment";
import if65Autocomplete from "../../components/widgets/If65Autocomplete";
import If65MultiSelect from "../../components/widgets/If65MultiSelect";
import axios from 'axios';
import authHeader from '/src/services/auth.header';

export default {
  components: {
    if65Autocomplete,
    If65DatePicker,
    TaskDeleteDialog,
    TaskDialog,
    CustomPagination,
    If65MultiSelect
  },
  data() {
    return {
      isInitializing: true, // Flag per evitare watcher durante inizializzazione
      autocompleteDataLoaded: false, // Flag per lazy loading degli autocomplete
      projectCodesLoaded: false,
      orderNumbersLoaded: false,
      operatorsLoaded: false,

      createdAtRangeToSearch: [],
      firstDate: '',
      firstTaskDate: '', // Data del primo task assoluto dal backend
      taskStats: null, // Statistiche complete dal backend
      benched: 0,
      filters: {
        customer: null,
        operators: [],
        project_name: [],
        activities: [],
        products: [],
        sub_activities: []
      },
      dtOptions: {
        itemsPerPage: 10
      },
      tasksCount: 0,
      project: null,
      projectId: null,
      projectCode: null, // Codice del progetto per l'autocomplete
      skipProjectCodeWatcher: false, // Flag per evitare loop nel watcher
      headers: [
        {class: "font-weight-medium primary--text", text: 'Ins', value: 'customer', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Op', value: 'operator_full_name', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Cod', value: 'project_code', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Prog', value: 'project_name', width: '180px'},
        {class: "font-weight-medium primary--text", text: 'Att', value: 'activity_name', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Prod', value: 'product_name', width: '180px'},
        {class: "font-weight-medium primary--text", text: 'Sub', value: 'sub_activity_name', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Data', value: 'task_date', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Ord', value: 'order_number', width: '120px'},
        {class: "font-weight-medium primary--text", text: 'Ore', value: 'hours', width: '80px', align: 'end'},
        {class: "font-weight-medium primary--text", text: 'Az', value: 'actions', width: '80px', sortable: false},
      ],
      showTaskDeleteDialog: false,
      showTaskDialog: false,
      tasks: [],
      taskToEdit: null,
      tasksStats: [],
      tasksStatsYesterday: [],
      orderNumberToSearch: '',
      codeNumberToSearch: '',
      task: null,
      loading: false,
      excelLoading: false,
      //
      interval: {},
      value: 0,
      absolute:false,
    }
  },
  props: {
    selectedProjectId: {
      default: null
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  watch: {
    excelLoading ()  {
      if (this.excelLoading) {
        this.interval = setInterval(() => {
          if (this.value === 100) {
            return (this.value = 0)
          }
          this.value += 5
        }, 1000)
      }
    },
    "dtOptions.page" (){
      console.log('📄 Cambio pagina a:', this.dtOptions.page);
      console.log('📄 Totale task:', this.tasksCount);
      console.log('📄 Items per page:', this.dtOptions.itemsPerPage);

      // Calcola il numero massimo di pagine
      const maxPages = Math.ceil(this.tasksCount / (this.dtOptions.itemsPerPage || 10));
      console.log('📄 Pagine massime:', maxPages);

      // Se la pagina richiesta è maggiore del massimo, vai alla prima
      if (this.dtOptions.page > maxPages && maxPages > 0) {
        console.log('🚨 Pagina troppo alta, resetto a 1');
        this.dtOptions.page = 1;
        return;
      }

      // Non impostiamo loading per la paginazione
      this.initTasks()
    },
    // Rimosso il watcher loading che causava ritardi inutili
    projectId: {
      handler() {
        if (this.isInitializing) return;
        this.initProject();
      }
    },
    projectCode: {
      handler(newCode) {
        // Salta se stiamo impostando il valore programmaticamente
        if (this.skipProjectCodeWatcher) {
          this.skipProjectCodeWatcher = false;
          return;
        }

        if (newCode && typeof newCode === 'string') {
          // Usa l'API solo dopo che è stata inizializzata
          this.$nextTick(() => {
            const apiFunc = this.projectCodeApi;
            if (typeof apiFunc === 'function') {
              apiFunc({choices: ''}).then(
                resp => {
                  const project = resp.data.find(p => p.value === newCode);
                  if (project && project.projectId) {
                    console.log('🔍 Trovato progetto per codice:', newCode, '-> ID:', project.projectId);
                    this.projectId = project.projectId;
                  }
                }
              ).catch(error => {
                console.error('Errore nella ricerca progetto per codice:', error);
              });
            }
          });
        } else if (!newCode) {
          // Se il codice è vuoto, resetta anche l'ID
          this.projectId = null;
        }
      }
    },
    filters: {
      handler() {
        if (this.isInitializing) return;
        this.debouncedInitTasks(); // Usa la versione debounced
      },
      deep: true,
    },
    orderNumberToSearch() {
      if (this.isInitializing) return;
      this.debouncedInitTasks(); // Usa la versione debounced
    },
    createdAtRangeToSearch() {
      if (this.isInitializing) return;
      if (this.createdAtRangeToSearch && this.createdAtRangeToSearch.length >= 2) {
        this.dtOptions.page = 1
        this.initTasks();
      } if (this.createdAtRangeToSearch === null) {
        this.createdAtRangeToSearch = []
        this.initTasks()
      }
    },
  },
  mounted() {
    this.projectId = this.$route.params.projectId || this.selectedProjectId
    // Inizializzazione immediata senza ritardi
    this.initProject();

    // Disabilita il flag dopo l'inizializzazione
    this.$nextTick(() => {
      this.isInitializing = false;
    });
  },
  computed: {
    prependExtraParams() {
      return this.projectId ? {project: this.projectId, choices: ''} : {choices: ''}
    },
    projectApi() {
      return this.$projectService.list;
    },
    projectCodeApi() {
      // Lazy loading: carica solo quando necessario
      if (!this.projectCodesLoaded) {
        return () => Promise.resolve({data: []});
      }

      // API specifica per l'autocomplete del codice progetto
      const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000/api/';
      return (params) => {
        try {
          return axios.get(`${API_URL}project/ids/`, {
            headers: authHeader(),
            params: params
          });
        } catch (error) {
          console.error('Errore in projectCodeApi:', error);
          return Promise.resolve({data: []});
        }
      };
    },
    orderNumberApi() {
      // Lazy loading per numeri ordine
      if (!this.orderNumbersLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$orderService && this.$orderService.list ? this.$orderService.list : () => Promise.resolve({data: []});
    },
    operatorApi() {
      // Lazy loading per operatori
      if (!this.operatorsLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$userService && this.$userService.list ? this.$userService.list : () => Promise.resolve({data: []});
    },
    safeActivityService() {
      // Lazy loading: restituisce dati vuoti se non ancora caricati
      if (!this.autocompleteDataLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$activityService && this.$activityService.list ? this.$activityService.list : () => Promise.resolve({data: []});
    },
    safeProductService() {
      if (!this.autocompleteDataLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$productService && this.$productService.list ? this.$productService.list : () => Promise.resolve({data: []});
    },
    safeSubActivityService() {
      if (!this.autocompleteDataLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$subActivityService && this.$subActivityService.list ? this.$subActivityService.list : () => Promise.resolve({data: []});
    },
    safeCustomerService() {
      if (!this.autocompleteDataLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$customerService && this.$customerService.list ? this.$customerService.list : () => Promise.resolve({data: []});
    },
    safeUserService() {
      if (!this.autocompleteDataLoaded) {
        return () => Promise.resolve({data: []});
      }
      return this.$userService && this.$userService.list ? this.$userService.list : () => Promise.resolve({data: []});
    },
    listParams() {
      const params = {
        page: this.dtOptions.page || 1,
        page_size: this.dtOptions.itemsPerPage || 10,
      };

      // Aggiungiamo solo parametri validi e non vuoti
      if (this.filters.customer) {
        params.customer = this.filters.customer;
      }

      if (this.projectId) {
        params.project = this.projectId;
      }

      if (this.orderNumberToSearch && this.orderNumberToSearch.trim()) {
        params.order_number = this.orderNumberToSearch;
      }

      if (this.codeNumberToSearch && this.codeNumberToSearch.trim()) {
        params.code_number = this.codeNumberToSearch;
      }

      if (this.createdAtRangeToSearch && this.createdAtRangeToSearch.length >= 2) {
        params.created_at_range = this.createdAtRangeToSearch.join(',');
      }

      if (this.filters.operators && this.filters.operators.length > 0) {
        params.operators = this.filters.operators.join(',');
      }

      if (this.filters.project_name && this.filters.project_name.length > 0) {
        params.project_name = this.filters.project_name.join(',');
      }

      if (this.filters.activities && this.filters.activities.length > 0) {
        params.activities = this.filters.activities.join(',');
      }

      if (this.filters.products && this.filters.products.length > 0) {
        params.products = this.filters.products.join(',');
      }

      if (this.filters.sub_activities && this.filters.sub_activities.length > 0) {
        params.sub_activities = this.filters.sub_activities.join(',');
      }

      return params;
    },
    ordering() {
      const {sortBy, sortDesc, page, pagePerItem} = this.dtOptions
      console.log(page, pagePerItem)
      if (sortBy && sortDesc && sortBy.length === 1 && sortDesc.length === 1) {
        return {ordering: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`}
      }
      return {}
    },
    totalHours() {
      const totalDecimalHours = _.sumBy(this.tasksStats, item => parseFloat(item.hours || 0));
      return this.formatDecimalHoursToHours(totalDecimalHours);
    },
    isAdmin() {
      return this.$store.state.user && ['ADMIN', 'HEAD', 'PURCHASE_OPERATOR'].includes(this.$store.state.user.role);
    },
    totalHoursYesterday() {
      const totalDecimalHours = _.sumBy(this.tasksStatsYesterday, item => parseFloat(item.hours || 0));
      return this.formatDecimalHoursToHours(totalDecimalHours);
    },
    hasActiveFilters() {
      return (
        (this.filters.customer && this.filters.customer !== null) ||
        (this.filters.operators && this.filters.operators.length > 0) ||
        (this.filters.project_name && this.filters.project_name.length > 0) ||
        (this.filters.activities && this.filters.activities.length > 0) ||
        (this.filters.products && this.filters.products.length > 0) ||
        (this.filters.sub_activities && this.filters.sub_activities.length > 0) ||
        (this.createdAtRangeToSearch && this.createdAtRangeToSearch.length > 0) ||
        (this.orderNumberToSearch && this.orderNumberToSearch.trim() !== '')
      );
    }
  },
  created() {
    // Creiamo una versione debounced di initTasks per i filtri
    this.debouncedInitTasks = debounce(() => {
      this.initTasks();
    }, 300); // Ridotto a 300ms per migliorare la reattività
  },
  methods: {

    // Metodi per attivare il lazy loading delle autocomplete
    enableProjectCodeAutocomplete() {
      if (!this.projectCodesLoaded) {
        this.projectCodesLoaded = true;
        console.log('🚀 Project codes autocomplete attivato');
      }
    },
    enableOrderNumberAutocomplete() {
      if (!this.orderNumbersLoaded) {
        this.orderNumbersLoaded = true;
        console.log('🚀 Order numbers autocomplete attivato');
      }
    },
    enableOperatorAutocomplete() {
      if (!this.operatorsLoaded) {
        this.operatorsLoaded = true;
        console.log('🚀 Operators autocomplete attivato');
      }
    },
    enableGeneralAutocompletes() {
      if (!this.autocompleteDataLoaded) {
        this.autocompleteDataLoaded = true;
        console.log('🚀 General autocompletes attivati');
      }
    },

    updateItemsPerPage(itemsPerPage) {
      this.dtOptions.itemsPerPage = itemsPerPage;
      this.initTasks();
    },
    clearAllFilters() {
      // Non mostriamo il loader per evitare blocchi

      // Resettiamo tutti i filtri
      this.filters = {
        customer: null,
        operators: [],
        project_name: [],
        activities: [],
        products: [],
        sub_activities: []
      };

      // Resettiamo gli altri filtri
      this.createdAtRangeToSearch = [];
      this.orderNumberToSearch = '';

      // Resettiamo la pagina
      this.dtOptions.page = 1;

      // Ricarichiamo i task
      this.initTasks();

      // Mostriamo un messaggio di conferma
      this.$dtoast.pop({
        preset: "success",
        content: 'Filtri cancellati',
      });
    },
    initialOperator(full_name) {
      var names = full_name.split(' '),
          initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    },
    truncateString(str, num) {
        if (str.length > num) {
          return str.slice(0, num) + "...";
        } else {
          return str;
        }
      },
    getInitials(fullName) {
      if (!fullName) return '';
      return fullName.split(' ')
        .map(name => name.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('');
    },
    formatMinutesToHours(minutes) {
      if (!minutes || minutes === 0) return '0:00';
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours}:${mins.toString().padStart(2, '0')}`;
    },
    formatDecimalHoursToHours(decimalHours) {
      if (!decimalHours || decimalHours === 0) return '0:00';
      const hours = Math.floor(parseFloat(decimalHours));
      const minutes = Math.round((parseFloat(decimalHours) - hours) * 60);
      return `${hours}:${minutes.toString().padStart(2, '0')}`;
    },
    formatDate(isoDate) {
      return isoDate ? format(parseISO(isoDate), 'dd/MM/yyyy') : '-'
    },
    canManipulate(task) {
      if (!this.$store.state.user) return false;

      // Controlla i permessi di eliminazione task
      if (this.$store.getters.canDeleteAllTasks) {
        return true;
      }

      if (this.$store.getters.canDeleteOwnTasks && this.$store.state.user.id === task.operator) {
        return true;
      }

      return false;
    },

    canEditTask(task) {
      if (!this.$store.state.user) return false;

      // Controlla i permessi di modifica task
      if (this.$store.getters.canEditAllTasks) {
        return true;
      }

      if (this.$store.getters.canEditOwnTasks && this.$store.state.user.id === task.operator) {
        return true;
      }

      return false;
    },
    deleteTask(item) {
      this.task = item
      this.showTaskDeleteDialog = true;
    },
    editTask(item) {
      this.taskToEdit = item.id
      console.log(item)
      this.showTaskDialog = true;
    },
    initProject() {
      this.project = null;
      if (this.projectId) {
        this.$projectService.get(this.projectId, {detail: ''}).then(
          resp => {
            if (this.$store.state.user && (
              resp.data.operator_ids.includes(this.$store.state.user.id) ||
              this.$store.getters.isAdmin ||
              this.$store.getters.userPermissions.project_access === 'all'
            )) {
              this.project = resp.data.name;

              // Imposta il codice del progetto
              const customId = resp.data.custom_id;
              if (customId) {
                // Usa nextTick invece di setTimeout per essere più veloce
                this.$nextTick(() => {
                  this.skipProjectCodeWatcher = true;  // Evita il watcher
                  this.projectCode = customId;
                });
              }

              this.initTasks();
            }
          }
        )
      } else {
        this.projectCode = null;
        this.initTasks()
      }
    },
    initTasks() {
      console.log('⚡ initTasks chiamato - params:', this.listParams);

      // Imposta loading
      this.loading = true;

      // UNICA chiamata API - combina tutto
      this.$taskService.listWithStats(this.listParams).then(
        resp => {
          console.log('✅ Dati ricevuti:', resp.data);

          // Task principali
          this.tasks = resp.data.results || [];
          this.tasksCount = resp.data.count || 0;
          const lastTask = _.last(this.tasks);
          this.firstDate = lastTask ? lastTask.task_date : '-';

          // Tutte le statistiche dalla stessa risposta
          this.tasksStats = resp.data.stats || [];
          this.tasksStatsYesterday = resp.data.stats_yesterday || [];
          this.taskStats = resp.data.task_stats || null;

          console.log('✅ Caricamento completato');
        }
      ).catch(error => {
        console.error('❌ Errore caricamento task:', error);

        // Se è un errore 404, resettiamo alla pagina 1
        if (error.response && error.response.status === 404) {
          this.dtOptions.page = 1;
          this.$dtoast.pop({
            preset: "warning",
            content: 'Pagina non trovata. Tornando alla prima pagina.',
          });
          // Riprova immediatamente con la pagina 1
          this.initTasks();
          return; // Non impostare loading=false qui per evitare flash
        } else {
          this.$dtoast.pop({
            preset: "error",
            content: 'Errore nel caricamento dei task',
          });
        }
      }).finally(() => {
        // SEMPRE disabilita il loading alla fine
        this.loading = false;
        console.log('🏁 Loading disabilitato');
      });
    },
    onTaskDeleteConfirmed() {
      this.showTaskDeleteDialog = false;
      this.initTasks();
    },
    onTaskSaved() {
      console.log('📥 TasksProject - onTaskSaved called');
      this.showTaskDialog = false;
      console.log('🔄 TasksProject - Calling initTasks...');
      this.initTasks();
    },
    exportInExcel() {
      this.excelLoading = true
      this.value = 0
      this.$taskService.exportExcel(this.listParams)
        .then(resp => {
          let now = moment().format('DD MM YYYY hh:mm:ss')
          FileSaver.saveAs(resp.data, `RiepilogoOre-${now}.xlsx`)
          this.excelLoading = false
        })
    }
  }
}
</script>
<style>
.my_class td{
  font-size: 12px!important;
  height: 1!important;
}

.task-table {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.task-table .v-data-table__wrapper {
  overflow-x: auto;
  max-width: 100%;
  min-width: 100%;
}

.task-table table {
  border-spacing: 0;
  table-layout: auto !important; /* Cambiato da fixed ad auto per adattarsi ai contenuti */
  min-width: 1360px; /* Larghezza minima per assicurarsi che tutte le colonne siano visibili */
  width: 100%;
}

.task-table tbody tr {
  transition: background-color 0.2s ease;
}

.task-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.task-table tbody td {
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  font-family: 'Poppins', sans-serif !important;
  padding: 6px 8px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.task-table thead th {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  font-family: 'Poppins', sans-serif !important;
  padding: 8px 8px !important;
  background-color: #f9fafc;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

/* Stili per la card delle ore giornaliere */
.v-virtual-scroll .v-list-item {
  min-height: 24px !important;
}

.v-virtual-scroll .v-list-item-title {
  line-height: 1.2 !important;
  margin-bottom: 4px;
}

.v-virtual-scroll .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

/* Stili per i pulsanti di cancellazione dei filtri */
.filter-row .v-btn.v-btn--icon.v-size--x-small {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  background-color: rgba(244, 67, 54, 0.1) !important;
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10 !important;
}

.filter-row .v-btn.v-btn--icon.v-size--x-small .v-icon {
  font-size: 16px !important;
}

.filter-row .d-flex.align-center {
  position: relative !important;
}

/* Stile per evidenziare i filtri attivi */
.filter-row .v-input--is-focused .v-input__slot,
.filter-row .v-select.v-select--is-menu-active .v-input__slot {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 0 0 1px var(--v-primary-base) !important;
}

/* Stile per la riga dei filtri */
.filter-row td {
  padding: 4px 8px !important;
  vertical-align: top !important;
  min-width: 120px !important;
  max-width: none !important;
  overflow: visible !important;
}

/* Assicuriamo che i menu dei filtri siano sempre visibili */
.filter-row .v-menu__content {
  max-height: 400px !important;
  overflow-y: auto !important;
}

/* Miglioriamo il layout dei filtri */
.filter-row {
  height: auto !important;
  min-height: 60px !important;
}

.filter-row td {
  padding: 8px 4px !important;
  vertical-align: top !important;
  width: auto !important;
  min-width: 150px !important;
  max-width: 200px !important;
}

/* Assicuriamo che i chip selezionati siano sempre visibili */
.filter-row .v-select__selections {
  overflow: visible !important;
  white-space: normal !important;
  flex-wrap: wrap !important;
  max-height: none !important;
}

/* Aumentiamo l'altezza del contenitore dei chip per mostrare più elementi */
.filter-row .v-input__slot {
  min-height: 48px !important;
  height: auto !important;
}

/* Gestiamo meglio l'overflow dei filtri */
.filter-row .v-input {
  width: 100% !important;
}

.filter-row .flex-grow-1 {
  min-width: 0 !important;
  flex: 1 1 auto !important;
}

/* Stili semplici per le card */
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.border-bottom:last-child {
  border-bottom: none !important;
}

/* RIMUOVE L'EFFETTO HOVER DA TUTTE LE CARD */
.v-card:hover {
  box-shadow: none !important;
  transform: none !important;
}

/* RIMUOVE L'EFFETTO HOVER DA TUTTI I PULSANTI */
.v-btn:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Pulsante Esporta Excel verde */
.excel-export-btn {
  color: #4CAF50 !important;
}

.excel-export-btn .v-icon {
  color: #4CAF50 !important;
}

/* Card espandibile per le ore degli operatori */
.expandable-hours-card {
  transition: height 0.3s ease;
  overflow: visible;
  z-index: 1;
  position: relative;
}

.expandable-hours-card:hover {
  height: auto !important;
  min-height: 150px !important;
  max-height: 400px !important;
  z-index: 1000;
  position: absolute !important;
  width: 100% !important;
  top: 0 !important;
  left: 0 !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.operators-list {
  max-height: 100px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.expandable-hours-card:hover .operators-list {
  max-height: 300px;
  overflow-y: auto;
}

.operator-item {
  transition: all 0.2s ease;
  opacity: 1;
  transform: translateY(0);
}

.hidden-item {
  opacity: 0.7;
  transform: translateY(-5px);
}

.expandable-hours-card:hover .hidden-item {
  opacity: 1;
  transform: translateY(0);
}

/* Icona chevron che ruota */
.expandable-hours-card .v-icon {
  transition: transform 0.3s ease;
}

.expandable-hours-card:hover .v-icon[class*="chevron"] {
  transform: rotate(180deg);
}

/* Scrollbar personalizzata per la lista operatori */
.operators-list::-webkit-scrollbar {
  width: 4px;
}

.operators-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 2px;
}

.operators-list::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 2px;
}

.operators-list::-webkit-scrollbar-thumb:hover {
  background: rgba(25, 118, 210, 0.5);
}

/* Stili per il footer della tabella */
.table-footer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: 2px solid #e9ecef;
  min-height: 80px;
}

.footer-stats {
  gap: 8px;
}

.stat-item {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  min-width: 140px;
}

.stat-item:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.hours-summary {
  background: rgba(76, 175, 80, 0.05) !important;
  border-color: rgba(76, 175, 80, 0.2) !important;
}

.hours-summary:hover {
  background: rgba(76, 175, 80, 0.1) !important;
  border-color: rgba(76, 175, 80, 0.3) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.15) !important;
}

.stat-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.stat-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #495057;
  white-space: nowrap;
}

.stat-value {
  font-size: 1rem;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.date-info {
  font-size: 0.75rem;
  font-style: italic;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .footer-stats {
    justify-content: center !important;
  }

  .stat-item {
    min-width: 120px;
    margin-bottom: 8px !important;
  }
}

@media (max-width: 768px) {
  .stat-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .date-info {
    margin-left: 0 !important;
    margin-top: 2px;
  }

  .stat-item {
    min-width: 100px;
    padding: 6px 8px;
  }
}
</style>
